import { omit, pick } from '@styled-system/props';
import React from 'react';

import { ComponentProps } from '../utils/types';
import { StyledInput, StyledInputBase, StyledOutlinedInput } from './styles';
import { InputProps as InputPropsInterface } from './types';

const inputVariants = {
  standard: StyledInput,
  outlined: StyledOutlinedInput
};

const Input = React.forwardRef<
  HTMLInputElement | HTMLTextAreaElement,
  InputPropsInterface
>(
  (
    {
      id,
      label,
      type = 'text',
      rightAddon,
      variant = 'standard',
      helperText,
      error,
      multiline,
      ...rest
    },
    ref
  ) => {
    const wrapperProps = pick(rest);
    const inputProps = omit(rest);

    const InputComponent = inputVariants[variant];

    return (
      <InputComponent error={error} multiline={multiline} {...wrapperProps}>
        <StyledInputBase
          as={multiline ? 'textarea' : 'input'}
          type={type}
          id={id}
          placeholder={label}
          ref={ref}
          {...inputProps}
        />
        {label && <label htmlFor={id}>{label}</label>}
        {rightAddon}
        {helperText && <span>{helperText}</span>}
      </InputComponent>
    );
  }
);

export type InputProps = ComponentProps<typeof Input>;
export default Input;
